<template>
    <div>
        <!-- Titulo -->
        <h3 class="mt-1 mb-2 " v-text="titulo"></h3>     

        <!--Filtro -->
        <b-card class="my-3">
            <b-row  align-self="start">
                <b-col class="col-md-6">
                    <b-form-group 
                        label="Categoria"  
                        label-size="sm"                                                             
                    >
                        <b-form-input                                            
                            id="categoria"                                                                                               
                            v-model="filtro.nome_categoria.value"    
                            placeholder="Informe a categoria que deseja pesquisar"            
                        >
                        </b-form-input>
                    </b-form-group>  
                </b-col>           
            </b-row>
                            
            <b-row align-self="start">                           
                <b-col class="col-md-4">                              
                    <b-form-group 
                        label="Situação"
                        label-size="sm"                                                               
                    >
                        <b-form-radio-group                                                      
                            id="ind_ativo"                
                            :options="filtro.ind_ativo.options"                                            
                            v-model="filtro.ind_ativo.value"
                        >
                        </b-form-radio-group>
                
                    </b-form-group>  
                </b-col>                       
            </b-row>
            <b-row>
                <b-col class="text-right">                            
                    <b-btn class="col-sm-12 col-md-auto" variant="primary" @click="listar" >                        
                       <i class="fa fa-search pr-1"></i> Pesquisar
                    </b-btn>           
                </b-col>
            </b-row>
        </b-card>

        <!-- Tabela -->
        <b-card >                
            <alert
                :variant="alert.variant"            
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert>  

            <b-row class="mb-2">
                <b-col class="text-right">
                    <b-btn class="col-sm-12 col-md-auto" variant="outline-secondary" @click="incluir"  >
                        <i class="fa fa-file-o pr-1"></i> Nova Categoria
                    </b-btn>                                       
                </b-col>
            </b-row>
          
            <b-row class="mx-0">
                <b-table 
                    no-provider-paging 
                    small  
                    responsive                 
                    :current-page="tabela.currentPage"
                    :empty-text="tabela.emptyText"
                    :fields="tabela.fields"                                                               
                    :items="tabela.items"
                    :per-page="tabela.perPage"    
                    :show-empty="tabela.showEmpty"
                    :striped="tabela.striped"                
                >     

                    <template v-slot:cell(ind_ativo)="data" >
                        {{getDescricaoSituacao(data.value)}}                   
                    </template>

                    <template v-slot:cell(dt_criacao)="data" >
                        {{$helper.formatDataHoraMinutoSegundo(data.value)}}                   
                    </template>

                    <template v-slot:cell(dt_atualizacao)="data" >
                        {{$helper.formatDataHoraMinutoSegundo(data.value)}}                   
                    </template>
                         <template v-slot:cell(ver)="data" >
                        <i class="fa fa-eye fa-lg" @click="visualizar(data.item)"></i>                    
                    </template>

                    <template v-slot:cell(editar)="data" >
                        <i class="fa fa-pencil fa-lg" @click="editar(data.item)" ></i>                    
                    </template>

                    <template v-slot:cell(excluir)="data" >
                        <i class="fa fa-trash fa-lg" @click="excluir(data.item)"></i>                    
                    </template>                

                </b-table>
            </b-row>
            <b-row align-h="end">
                <b-col class="col-md-3">
                    <b-form-group                       
                        label-cols="8"
                        label="Itens por página:"
                        label-align="right"
                        label-size="sm"   
                        label-class="mt-1 text-secondary"                                                                                                                                                        
                    >                        
                        <b-form-select 
                            v-model="tabela.perPage"
                            size="sm"
                            :options="tabela.pageOptions"
                            @change="tabela.currentPage=1"                            
                            >
                        </b-form-select>
                    </b-form-group> 
                </b-col>
                <b-col class="col-md-3">
                    <b-pagination v-show="tabela.totalRows > tabela.perPage" align="right"
                        :total-rows="tabela.totalRows" 
                        :per-page="tabela.perPage" 
                        :value="tabela.currentPage"                  
                        @change="mudaPagina" 
                        class="mt-2" 
                        size="sm"
                    >
                    </b-pagination>
                </b-col>
            </b-row>
        </b-card>   

    </div>

</template>

<script>

import Alert from '../../../models/Alert'
import CategoriaAto from '../../../models/CategoriaAto'

export default {

    data(){
        return {
            titulo: "Categorias",

            filtro: {
                nome_categoria: {
                    value: ''
                },
                ind_ativo: {
                    value: null,
                    options:[
                        { value: null , text: 'Todos' },
                        { value: true, text: 'Ativos' },     
                        { value: false, text: 'Inativos' },     
                    ],
                }                
            },

            tabela:{                
                currentPage: 1,
                items: [],
                emptyText:'Nenhum registro encontrado',
                fields: [               
                    {
                        key: 'nome_categoria',
                        label: 'Categoria',
                        sortable: true,                                                           
                    },
                    {
                        key: 'ind_ativo',
                        label: 'Situação',
                        sortable: true,  
                        class: 'text-center'                                                                                                                                     
                    }, 
                    {
                        key: 'dt_criacao',
                        label: 'Data Cadastro',
                        sortable: true, 
                        class: 'text-center'                                                                                                                 
                    }, 
                    {
                        key: 'dt_atualizacao',
                        label: 'Data Atualização',
                        sortable: true, 
                        class: 'text-center'                                                                                                                 
                    }, 
                    {
                        key: 'ver',
                        label: '',  
                        class: 'text-center'                                              
                    },
                    {
                        key: 'editar',
                        label: '', 
                        class: 'text-center'                                               
                    },
                                        {
                        key: 'excluir',
                        label: '',  
                        class: 'text-center'                                              
                    },                       
                                   
                ],
                perPage: 10,
                showEmpty: true,
                striped: true,
                totalRows: 0,   
                pageOptions: [10, 25, 50],                                       
            },
                                    
            alert: new Alert(),
        }
    },
    
    methods: {
        alertDismissed(){           
            this.alert = new Alert();
        },
        
        mudaPagina(pagina) {
            this.tabela.currentPage = pagina;                    
        },

        getDescricaoSituacao(situacao){        
            return (situacao ? 'Ativo' : 'Inativo');
        },        
  
        incluir(){  
            this.$router.push({ name: 'categoriaAtoForm', params: {id:'new'} });
        },

        visualizar(categoria){  
            this.$router.push({ name: 'categoriaAtoFormView', params: { id:categoria.id} });   
        },

        editar(categoria){            
            this.$router.push({ name: 'categoriaAtoForm', params: { id:categoria.id} });              
        },

        listar(){
            let parametros = { 
                nome_categoria: this.filtro.nome_categoria.value, 
                ind_ativo: this.filtro.ind_ativo.value
            };
            
            this.$api.categoriaAto.listar(parametros)
                .then(response => {                         
                    this.tabela.items = [];                                    
                    response.data.data.forEach(categoria => {                                                                                
                        this.tabela.items.push(new CategoriaAto(categoria)); 
                    });  
                    this.tabela.totalRows = response.data.data.length;  
                    this.mudaPagina(1);
                })
                .catch(error => {   
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                                           
                }); 
        },

        excluir(item){
            let situacao = this.getDescricaoSituacao(item.ind_ativo);
            let message = 'Confirma a exclusão da categoria '+item.nome_categoria+' com situação '+situacao+'?'                            
            this.$helper.confirmaExclusao(this, message)
                .then(value => {
                    if(value){
                        this.$api.categoriaAto.excluir(item.id)
                            .then(response => {                    
                                if(response.status == 200 || response.status == 201){                                                                                         
                                    this.listar();                                      
                                    this.$helper.showAlert(this.alert, 
                                                           this.$constantes.alert.variants.SUCCESS,
                                                           'Registro excluído com sucesso!');    
                                }
                            })
                            .catch(error => {                              
                                this.$helper.showAlert(this.alert, 
                                                       this.$constantes.alert.variants.DANGER,
                                                       error.response.data.errors);     
                            });          
                        
                        this.$helper.scrollWindowToTop();
                    }
                });            
        },
    }, 
    
    mounted(){     
        this.listar();        
    },
}
</script>


